import React, { useContext, useEffect, useState } from 'react';
import SideLeft from '../layout/SideLeft';
import StatAbonnement from '../components/StatAbonnement';
import MainLayout from '../layout/MainLayout';
import CenterLayout from '../layout/CenterLayout';
import StatProjects from '../components/StatProjects';
import StatProjectInfo from '../components/StatProjectInfo';
import StatSubscriber from '../components/StatSubscriber';
import AppContext from '../Context/AppContext';
import ServerStream from '../components/ServerStream';
import ServerAll from '../components/ServerAll';
import ServerClean from '../components/ServerClean';

const Server = () => {
    const [tab, setTab] = useState('stockage')
    const [compCenter, setCompCenter] = useState(<ServerAll />)
    const { setCurrentPage } = useContext(AppContext)
    useEffect(() => {
        setCurrentPage('server')
    }, [])
    const select = (key, comp) => {
        setTab(key)
        setCompCenter(comp)
    }
    return (
        <MainLayout>
            <CenterLayout>
                <nav className="gap1 df">
                    <button onClick={() => select('stockage', <ServerAll />)} className={`card carder cw ${tab === 'stockage' ? 'active' : ''}`}>Videos Stockage</button>
                    <button onClick={() => select('stream', <ServerStream />)} className={`card carder cw ${tab === 'stream' ? 'active' : ''}`}>Videos Stream</button>
                    <button onClick={() => select('clean', <ServerClean />)} className={`card carder cw ${tab === 'clean' ? 'active' : ''}`}>Clean</button>
                </nav>
                {compCenter}
            </CenterLayout>
            <SideLeft>
                <ServerStream />
            </SideLeft>
        </MainLayout>

    );
};

export default Server;